(()=>{
 if(window.fsmProductReviewsInitialized)return;
 window.fsmProductReviewsInitialized=true;
 const firstPages=new Map();
 function fetchPage(id,page){
  if(page===1&&firstPages.has(id))return firstPages.get(id);
  const request=(async()=>{
   const abort=new AbortController(),timer=setTimeout(()=>abort.abort(),10000);
   try{
    const response=await fetch('https://termine.flugsimulator-ms.de/api/public-product-reviews?product='+encodeURIComponent(id)+'&page='+page,{credentials:'omit',signal:abort.signal,cache:'no-store'});
    if(!response.ok)throw new Error('feed');const data=await response.json();
    if(data.productId!==id||!Number.isSafeInteger(data.ratingCount)||data.ratingCount<0||!Array.isArray(data.reviews)||(data.ratingCount>0&&(!Number.isFinite(data.ratingValue)||data.ratingValue<1||data.ratingValue>5)))throw new Error('data');
    return data;
   }finally{clearTimeout(timer);}
  })();
  if(page===1){firstPages.set(id,request);request.catch(()=>firstPages.delete(id));}
  return request;
 }
 async function setupRating(badge){
  if(badge.dataset.fsmRatingReady)return;badge.dataset.fsmRatingReady='1';
  try{
   const data=await fetchPage(badge.dataset.fsmRatingProduct,1);
   if(!data.ratingCount){badge.hidden=true;return;}
   const stars=badge.querySelector('.fsm-rating-stars');
   stars.style.setProperty('--fsm-rating-percent',data.ratingValue*20+'%');
   const value=data.ratingValue.toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2});
   stars.setAttribute('aria-label',value+' von 5 Sternen');
   badge.querySelector('.fsm-rating-value').textContent=value+' / 5';
   badge.querySelector('.fsm-rating-count').textContent='('+data.ratingCount+' Bewertungen)';
   badge.hidden=false;
  }catch{badge.hidden=true;delete badge.dataset.fsmRatingReady;}
 }

 const make=(tag,cls,text)=>{const e=document.createElement(tag);if(cls)e.className=cls;if(text!==undefined)e.textContent=text;return e;};
 function setup(root){
  if(root.dataset.fsmReady)return;root.dataset.fsmReady='1';
  const id=root.dataset.fsmProduct,score=root.querySelector('.fsm-pr-score'),cards=root.querySelector('.fsm-pr-cards'),button=root.querySelector('.fsm-pr-more');let page=0,busy=false;
  const schema=document.querySelector('script[data-fsm-product-schema="'+id+'"]');
  function rating(data){
   if(!schema)return;const value=JSON.parse(schema.textContent);delete value.aggregateRating;
   if(data.ratingCount>0)value.aggregateRating={'@type':'AggregateRating',ratingValue:data.ratingValue,ratingCount:data.ratingCount,bestRating:5,worstRating:1};
   schema.textContent=JSON.stringify(value).replace(/</g,'\\u003c');
  }
  async function load(){
   if(busy)return;busy=true;button.disabled=true;
   try{
    const data=await fetchPage(id,page+1);
    if(page===0){root.hidden=data.ratingCount===0;cards.replaceChildren();score.replaceChildren();if(data.ratingCount){score.append(make('span','fsm-pr-stars','★ '),make('span','',data.ratingValue.toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2})+' / 5 · '+data.ratingCount+' Bewertungen'));}else score.textContent='Noch keine Produktbewertungen';rating(data);}
    for(const r of data.reviews){const card=make('article','fsm-pr-card'),stars=make('div','fsm-pr-stars','★'.repeat(r.rating)+'☆'.repeat(5-r.rating));stars.setAttribute('aria-label',r.rating+' von 5 Sternen');card.append(stars,make('div','fsm-pr-meta',r.author+' · '+r.date.split('-').reverse().join('.')+' · '+r.source));if(r.comment)card.append(make('p','',r.comment));if(r.response){const reply=make('aside','');reply.append(make('b','','Antwort von Flugsimulator Münster'),make('p','',r.response));card.append(reply);}cards.append(card);}
    page=data.page;button.hidden=!data.hasMore;button.textContent='Weitere Bewertungen';
   }catch{if(!page){score.textContent='Produktbewertungen momentan nicht verfügbar';}button.hidden=false;button.textContent='Erneut laden';}
   finally{busy=false;button.disabled=false;}
  }
  button.addEventListener('click',load);load();
 }
 function start(){document.querySelectorAll('[data-fsm-rating-product]').forEach(setupRating);document.querySelectorAll('[data-fsm-product]').forEach(setup);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
 document.addEventListener('shopify:section:load',start);
})();
